<template>
  <div class="classification card new">
    <div class="inner">
      <!-- <el-descriptions title="部门信息"
                       :colon="false">
        <el-descriptions-item label="部门">{{
          userInfo && userInfo.deptName
        }}</el-descriptions-item>
      </el-descriptions> -->
      <el-descriptions title="支付绑定"
                       :colon="false">
        <el-descriptions-item label="康贝商户">{{merchantNo}} </el-descriptions-item>
        <el-descriptions-item label=""><span @click="submitBtn"
                style="color: #F5222D; cursor: pointer">商户绑定
          </span></el-descriptions-item>
      </el-descriptions>
    </div>
    <el-dialog width="30%"
               title="商户绑定"
               :visible.sync="innerVisible"
               :close-on-click-modal="false"
               append-to-body>
      <el-form ref="form"
               :model="form"
               :rules="rules"
               label-width="80px">
        <el-form-item prop="merchantNo"
                      label="康贝商户">
          <el-input v-model.trim="form.merchantNo"
                    @blur="toUpperCase"
                    auto-complete="off"
                    placeholder="请输入商户号">
            <i slot="prefix"
               class="el-icon-mobile-phone"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="verifyCode"
                      label="验证码">
          <el-input class="verification-code"
                    v-model.trim="form.verifyCode"
                    auto-complete="off"
                    placeholder="请输入验证码">
            <i slot="prefix"
               class="el-icon-key"
               style="position:absolute;top:12px"></i>
            <template slot="append">
              <span :class="[{ display: msgKey }, { active: form.merchantNo }]"
                    class="msg-text"
                    @click="handleSend">{{ msgText }}</span>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button size="small"
                   @click="
            innerVisible = false
          ">取 消</el-button>
        <el-button size="small"
                   :loading="loading"
                   type="primary"
                   @click="
            innerVisible = true
            sureBtn()
          ">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
const MSGINIT = '发送验证码',
  MSGSCUCCESS = '${time}秒后重发',
  MSGTIME = 60

import { currentDetails } from '@/api/myQualification/index'
import { getUserInfo, merchantBind, findPhoneByMerchant } from '@/api/user.js'
// import { getStore } from '@/util/store'
export default {
  data () {
    return {
      loading: false,
      merchantNo: '',
      rules: {
        merchantNo: [
          { required: true, message: '请输入商户号', trigger: 'change' }
        ],
        verifyCode: [
          { required: true, message: '请输入验证码', trigger: 'change' }
        ],
      },
      innerVisible: false,
      form: {
        merchantNo: '',
        verifyCode: '',
      },
      msgKey: false,
      msgText: MSGINIT,
      msgTime: MSGTIME,
      phone: '',
      // userInfo: {},
    }
  },
  async created () {
    this.currentDetails()
    // await getUserInfo(getStore({ name: 'userId' })).then((res) => {
    //   this.userInfo = res.data.data
    //   this.userInfo.role = []
    //   this.userInfo.post = []
    //   res.data.data.roleList.map((item) => {
    //     this.userInfo.role.push(item.roleName)
    //   })
    //   res.data.data.postList.map((item) => {
    //     this.userInfo.post.push(item.postName)
    //   })
    // })
  },
  computed: {
    userInfo () {
      console.log(this.$store.state.user.user_info)
      return this.$store.state.user.user_info
    },
  },
  methods: {
    toUpperCase () {
      this.form.merchantNo = this.form.merchantNo.toUpperCase()
    },
    // 查询康贝账户
    currentDetails () {
      currentDetails().then(res => {
        if (res.code == 0) {
          this.merchantNo = res.data?.merchantNo ?? ''
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    submitBtn () {
      this.innerVisible = true
      this.$refs.form?.resetFields()
    },
    sureBtn () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          merchantBind({
            phone: this.phone,
            verifyCode: this.form.verifyCode,
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success('商户绑定成功')
              this.merchantNo = this.form.merchantNo
              this.innerVisible = false
              this.form = {
                merchantNo: '',
                verifyCode: '',
              }
            } else {
              this.$message.error(res.msg)
              // this.form = {
              //   merchantNo: '',
              //   verifyCode: '',
              // }
            }
            this.loading = false
          }).catch(err => {
            this.loading = false
          })
        }
      })
    },
    handleSend () {
      // 判断是否可以发送（时间限制）
      if (this.msgKey) return
      // 发送验证码
      this.$refs.form.validateField('merchantNo', (valid) => {
        if (!valid) {
          findPhoneByMerchant({ merchantNo: this.form.merchantNo }).then(
            (res) => {
              if (res.code == 0) {
                this.$message.success('验证码发送成功')
                this.phone = res.data
                this.timeCacl()
              } else {
                this.$message.error(res.msg)
              }
            }
          )
        }
      })
    },
    timeCacl () {
      // 计时避免重复发送
      this.msgText = MSGSCUCCESS.replace('${time}', this.msgTime)
      this.msgKey = true
      const time = setInterval(() => {
        this.msgTime--
        this.msgText = MSGSCUCCESS.replace('${time}', this.msgTime)
        if (this.msgTime === 0) {
          this.msgTime = MSGTIME
          this.msgText = MSGINIT
          this.msgKey = false
          clearInterval(time)
        }
      }, 1000)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-input-group__append {
  cursor: pointer;
}
.classification {
  padding-top: 24px;
  .msg-text {
    display: block;
    width: 101px;
    font-size: 12px;
    text-align: center;
    cursor: pointer;
    padding: 12px 20px;
  }
}
</style>
